import { defineStore } from 'pinia';
import type { HomeStoreState, HotTicketItem, SuggestRouteItem } from '#/home';
import type { HomeQueryParam } from '@/logic/home/model';
export const useHomeStore: any = defineStore({
	id: 'app-home',
	state: (): HomeStoreState => ({
		homeScrollTop: 0, //滚动距离顶部距离
		queryInfo: {
			adultNum: 1,
			childNum: 0,
			infantNum: 0,
			fromCity: {
				cityName: '',
				cityCode: ''
			},
			toCity: {
				cityName: '',
				cityCode: ''
			},
			fromDate: '',
			retDate: '',
			cabinGrades: 'E',
			tripType: '',
			fromCityInfo: {},
			toCityInfo: {}
		},
		suggestRoute: [],
		hotTicket: [],
	}),
	actions: {
		setHomeScrollTop(scrollDistance: number) {
			this.homeScrollTop = scrollDistance;
		},
		setQueryParams(params: HomeQueryParam) {
			this.queryInfo.adultNum = params.adultNum;
			this.queryInfo.childNum = params.childNum;
			this.queryInfo.infantNum = params.infantNum;
			this.queryInfo.fromCity = params.fromCity;
			this.queryInfo.toCity = params.toCity;
			this.queryInfo.fromDate = params.fromDate;
			this.queryInfo.retDate = params.retDate;
			this.queryInfo.cabinGrades = params.cabinGrades;
			this.queryInfo.tripType = params.tripType;
			this.queryInfo.fromCityInfo = params.fromCityInfo;
			this.queryInfo.toCityInfo = params.toCityInfo;
		},
		setSuggestRoute(routeList: SuggestRouteItem[]) {
			this.suggestRoute = routeList;
		},
		setHotTicket(hotTicketList: HotTicketItem[]) {
			this.hotTicket = hotTicketList;
		}
	},
	getters: {
		getHomeScrollTop(): number {
			return this.homeScrollTop;
		},
		getQueryParams(): HomeQueryParam {
			return {
				adultNum: this.queryInfo.adultNum,
				childNum: this.queryInfo.childNum,
				infantNum: this.queryInfo.infantNum,
				fromCity: this.queryInfo.fromCity,
				toCity: this.queryInfo.toCity,
				fromDate: this.queryInfo.fromDate,
				retDate: this.queryInfo.retDate,
				cabinGrades: this.queryInfo.cabinGrades,
				tripType: this.queryInfo.tripType,
				fromCityInfo: this.queryInfo.fromCityInfo,
				toCityInfo: this.queryInfo.toCityInfo,
			};
		},
		getSuggestRoute(): SuggestRouteItem[] {
			return this.suggestRoute;
		},
		getHotTicket(): HotTicketItem[] {
			return this.hotTicket;
		}
	},
	//persist定义要做判断，因为localStorage是客户端参数，所以需要加process.client
	persist: process.client && {
		storage: sessionStorage,
		paths: ['queryInfo', 'hotTicket', 'suggestRoute']
	}
});

export const setHomeScrollTopFun = (distance: number) => {
	useHomeStore().setHomeScrollTop(distance);
};
export const getHomeScrollTopFun = () => {
	return useHomeStore().getHomeScrollTop;
};

export const setQueryParamsFun = (params: HomeQueryParam) => {
	useHomeStore().setQueryParams(params);
};

export const getQueryParamsFun = () => {
	return useHomeStore().getQueryParams;
};

export const setSuggestRouteFun = (routeList: SuggestRouteItem[]) => {
	useHomeStore().setSuggestRoute(routeList);
};

export const getSuggestRoutesFun = () => {
	return useHomeStore().setSuggestRoute;
};


export const setHotTicketFun = (hotTicketList: HotTicketItem[]) => {
	useHomeStore().setHotTicket(hotTicketList);
};

export const getHotTicketFun = () => {
	return useHomeStore().getHotTicket;
}

